// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleFilterCheckbox_base--P4814","input":"VehicleFilterCheckbox_input--2styo","check":"VehicleFilterCheckbox_check--2DZmE","base__isChecked":"VehicleFilterCheckbox_base__isChecked--3ORKm","baseIsChecked":"VehicleFilterCheckbox_base__isChecked--3ORKm"};


//////////////////
// WEBPACK FOOTER
// ./components/VehicleFilterCheckbox/VehicleFilterCheckbox.scss
// module id = 452
// module chunks = 11 12